// namespace
window.Components = window.Components || {};

(function($) {

  'use strict';

  function TextSection() {

    var self          = this,
      $cache        = {},
      controller_animations = null,
      scenes_animations = [];


    function createAnimationScenes() {
      controller_animations = new ScrollMagic.Controller({ 
        globalSceneOptions: {
          triggerHook: 'onLeave',
          duration: $('.text-section').height()*1.5
        }
      });
      
      var $itemsReverse = '.text-section .js-animate-rlo';

      var tl = new TimelineMax();
      tl.staggerFromTo($itemsReverse, 1, {x: 0}, {x: -200, force3D:true, ease: Quad.easeOut}, 0.075, 0);
      tl.staggerFromTo($itemsReverse, 0.8, {opacity: 1}, {opacity: 0, ease: Quad.easeOut}, 0.075, 0);

      var scene = new ScrollMagic.Scene({
            triggerElement: '.text-section',
          })
          .setTween(tl)
          //.addIndicators() // add indicators (requires plugin)
          .addTo(controller_animations);
      scenes_animations.push(scene);
    }

    /**
     * Generic resize
     */
    function onResize() {
      // Example
      if (window.bp.getLastValue() !== window.bp.getValue()) {
        if (window.bp.getValue() === 'xl') {
        }

        if (window.bp.getValue() === 'lg') {
        }

        if (window.bp.getValue() === 'md') {
        }

        if (window.bp.getValue() === 'sm') {
        }

        if (window.bp.getValue() === 'xs') {
        }
      }

      if(window.cache.$window.width() >= 768) createAnimationScenes();
    }


    /**
     * Public constructor
     * @param  {Object} opts Options
     */
    self.initialize = function() {

      // Caching

      if(window.cache.$window.width() >= 768) {
        createAnimationScenes();
      }
      
      window.cache.$window.on('resize', Utils.debounce(onResize, 3000));
      // Initial call on load
      onResize();
    };

    self.initialize.apply(self, arguments);
    return self;
  }
  
  window.Components.TextSection = TextSection;
  
}(jQuery));
